import React, {  Component } from 'react';

export default class UpdateCompleteForAccountAccessRequestOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="updateCompleteForAccountAccessRequestOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Update Complete</h2>
                    <p className="importantText bold">{this.props.message!==""?this.props.message:"Your request for access to additional accounts has been submitted."}</p>
					{this.props.message === ""
						?<p className="noMarginTop">Your request has been submitted and is pending approval of the account administrator and/or your GE Area Sales Manager.  You will be notified via email once approved.</p>
						:null
					}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/updateCompleteForAccountAccessRequestOverlayDialog.js